var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { PureComponent } from 'react';

var Image = function (_super) {
  __extends(Image, _super);

  function Image() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Image.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        imageurl = _a.imageurl,
        text = _a.text;
    return React.createElement("img", {
      className: className,
      style: style,
      src: imageurl,
      alt: text
    });
  };

  return Image;
}(PureComponent);

export { Image };